import { t } from '~/utils/localization';
import styles from './Tooltip.scss';
import { BundleRestrictInteractionType, UserPrerequisiteCondition } from '~/types/bundle';
import CountDown from '../CountDown/CountDown';
import classNames from 'classnames';

interface ILockedBundleTooltip {
    restrictInteraction: IBundleRestrictInteraction;
}

const LockedBundleTooltip = ({ restrictInteraction }: ILockedBundleTooltip) => {
    let message = null;
    let values;
    if (restrictInteraction.condition === UserPrerequisiteCondition.datetime) {
        message = t('Available for purchase after the timer ends.');
        values = restrictInteraction.values as BundleRestrictInteractionDateTimeValues;
    } else if (restrictInteraction.condition === UserPrerequisiteCondition.token) {
        message = restrictInteraction.values.description;
    }

    let restrictredText;
    if (restrictInteraction.type === BundleRestrictInteractionType.partial_with_price) {
        restrictredText = t('You can still view the contents, price, and description.');
    } else if (restrictInteraction.type === BundleRestrictInteractionType.partial) {
        restrictredText = t('You can still view the contents and description.');
    } else if (restrictInteraction.type === BundleRestrictInteractionType.full_with_price) {
        restrictredText = t('You can still view the price.');
    }

    const hasDescriptionForDateTimeCondition = restrictInteraction.condition === UserPrerequisiteCondition.datetime && !!restrictInteraction.values.description;
    const classesMessage = classNames({
        [styles.defaultTooltipBodyWithBorder]: hasDescriptionForDateTimeCondition,
        [styles.defaultTooltipBody]: !hasDescriptionForDateTimeCondition,
    });

    return (
        <div className={styles.defaultTooltip}>
            <div className={styles.defaultTooltipHeader}>{t('Locked bundle')}</div>
            {hasDescriptionForDateTimeCondition && <div className={styles.defaultTooltipBody}>{restrictInteraction.values.description}</div>}
            {message && <div className={classesMessage}>{message}</div>}
            {restrictredText && <div className={styles.defaultTooltipBodyWithBorder}>{restrictredText}</div>}
            <div className={classNames(styles.footer, styles.withPadding)}>
                <div className={styles.lockedBundleWrapper}>
                    {restrictInteraction.condition === UserPrerequisiteCondition.datetime ? (
                        <>
                            <span>{t('Unlocks in:')}</span>
                            <CountDown date={values.purchasableFrom} className={styles.lockedBundleTimer} withoutIcon />
                        </>
                    ) : (
                        <span>{restrictInteraction.condition === UserPrerequisiteCondition.token ? t('Requirement not met') : t('Locked')}</span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default LockedBundleTooltip;
